import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../utility/Utility";
import Swal from "sweetalert2";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

function HelpAndSupportCategoryList() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await postData("api/support/categories/list", {});

      if (response?.success) {
        // Filter categories based on search term if provided
        const filteredCategories = searchTerm 
          ? response.data.filter(category => 
              category.toLowerCase().includes(searchTerm.toLowerCase()))
          : response.data;
        
        setCategories(filteredCategories);
      } else {
        // toast.error(response?.message || "Failed to fetch categories");
      }
    } catch (error) {
      // toast.error("Error fetching categories");
      console.error("Fetch categories error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchCategories();
  };

  const handleReset = () => {
    setSearchTerm("");
    fetchCategories();
  };

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = async (category) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await postData(`api/support/categories/delete`, {
          category: category
        });
        if (response?.success) {
          // toast.success(response.message || "Category deleted successfully");
          fetchCategories();
        } else {
          // toast.error(response?.message || "Failed to delete category");
        }
      } catch (error) {
        // toast.error("Error deleting category");
        console.error("Delete category error:", error);
      }
    }
  };

  return (
    <div className="content-page">
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Help & Support Category Management</h4>
              <p className="fw-semibold my-2">Help & Support Category List</p>
            </div>
            <div>
              <button
                className="btn btn-primary"
                onClick={() => navigate("/add-help-and-support-category")}
                disabled={loading}
              >
                {loading ? "Adding..." : "Add Help & Support Category"}
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-center">
                      <div className="col-md-12 col-lg-4">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search categories..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <span className="input-group-text">
                            <i className="mdi mdi-magnify"></i>
                          </span>
                        </div>
                      </div>

                      <div className="col-md-12 col-lg-3 d-flex gap-2">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Searching..." : "Search"}
                        </button>

                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleReset}
                          disabled={loading}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Category Name</th>
                            <th width="150px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="3" className="text-center py-4">
                                Loading categories...
                              </td>
                            </tr>
                          ) : categories.length === 0 ? (
                            <tr>
                              <td colSpan="3" className="text-center py-4">
                                No categories found
                              </td>
                            </tr>
                          ) : (
                            categories.map((category, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{category}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDelete(category)}
                                    >
                                      <i className="mdi mdi-delete"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpAndSupportCategoryList;